import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import { AlertBannerContext } from "@kivunova/kivufrontendcommon";
import { fetchGraphQL } from "../../Graphql/utils";
import {
  verifyEmailOtpQuery,
  verifyOTPQuery
} from "../../Graphql/querries/verifyOTPQuery";
import {
  OtpVerifyEmailRequest,
  OtpVerifyEmailResponse,
  OtpVerifyRequest,
  OtpVerifyResponse
} from "../../components/common/OtpVerification/types/otpVerification";
import { captureAppException, buildLogContext } from "../../Utils/appLogger";

export const useVerifyEmailOtp = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<OtpVerifyEmailResponse, Error, OtpVerifyEmailRequest>({
    mutationKey: ["verifyEmailOtp"],
    mutationFn: (input) =>
      fetchGraphQL(verifyEmailOtpQuery, { input }, setAlert)
  });
};

export const useVerifyOTP = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<OtpVerifyResponse, Error, OtpVerifyRequest>({
    mutationKey: ["verifyOTP"],
    mutationFn: (input) =>
      fetchGraphQL(
        verifyOTPQuery,
        { email: input.email, otp: input.otp },
        setAlert
      ),
    onError: (error) => {
      captureAppException(
        "OTP verification failed",
        error,
        buildLogContext("auth", "verify-otp")
      );
    }
  });
};
